
<script>
export default {
  name: "ArtisanMenu",
  props: {
    menus: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    navTab(item) {
      this.$emit("click", item);
    },
  },
  render() {
    const buildChildren = (item) => {
      if (item.children && item.children.length) {
        return (
          <el-submenu index={item.code}>
            <template slot="title">
              {item.icon ? <i style="color:white" class={item.icon}></i> : ""}
              <span>{item.name}</span>
            </template>
            {item.children.map((c) => {
              return buildChildren(c);
            })}
          </el-submenu>
        );
      } else {
        return (
          <el-menu-item index={item.code}>
            <div
              on={{
                click: () => {
                  this.navTab(item);
                },
              }}
            >
              {item.icon ? <i style="color:white" class={item.icon}></i> : ""}
              <span>{item.name}</span>
            </div>
          </el-menu-item>
        );
      }
    };
    if (this.menus.length <= 7) {
      return (
        <el-menu {...{ attrs: this.$attrs }}>
          {this.menus.map((c) => {
            return buildChildren(c);
          })}
        </el-menu>
      );
    } else {
      let preArr = this.menus.filter((c, i) => i < 6);
      let more = {
        code: "more",
        name: "更多",
        icon: "el-icon-s-grid",
        children: this.menus.filter((c, i) => i >= 6),
      };
      return (
        <el-menu {...{ attrs: this.$attrs }}>
          {preArr.map((c) => {
            return buildChildren(c);
          })}
          {buildChildren(more)}
        </el-menu>
      );
    }
  },
};
</script>

<style scoped>
.el-menu >>> i.el-submenu__icon-arrow {
  color: #fff !important;
}
.el-submenu >>> i.el-submenu__icon-arrow {
  color: #fff !important;
}
.el-submenu >>> .el-submenu__title{
    padding:0 10px;
}
</style>
